module.exports = __webpack_public_path__ + "static/media/splashfiller2.9c41f4d9.gif";